import { defineStore } from 'pinia';
import { getDiagConfig, getDiagInfo } from '@/services/diagService';

export const useDiagStore = defineStore('DiagStore', {
  state: () => ({
    appVersion: {} as AppVersionType,
    diagConfig: [] as KeyValueType[],
  }),

  getters: {
    getAppVersion(store) {
      return store.appVersion;
    },
    getDiagConfig(store) {
      return store.diagConfig;
    },
  },

  actions: {
    async fetchDiagInfo() {
      this.appVersion = await getDiagInfo();
    },
    async fetchDiagConfig() {
      this.diagConfig = await getDiagConfig();
    },
  },
});
